/** @format */

import React, { Component } from "react";
import { Modal, Button, Breadcrumb } from "react-bootstrap";

import * as qs from "query-string";
import { toast } from "react-toastify";
import { Dropdown } from "react-bootstrap";
import debounce from "lodash.debounce";
import { ApiRoutes, AppRoutes, SocketEvents } from "../../../config";
import { ApiHelper } from "../../../helpers";
import Pagination from "../../components/pagination";
import {
  ListComponent,
  AddFormComponent,
} from "../../components/pushNotifications";
import { FilterComponent } from "../../components/filters";
import PHLContext from "../../../PHLContext";
import { SearchFilter } from "../../components/filters/searchFilter";
import filterarrowIcon from "../../../assets/img/filter-arrow.svg";
import pageDropdownIcon from "../../../assets/img/tag-bd.svg";
import mobSearchIcon from "../../../assets/img/tag-search-bd.svg";
import SweetAlertComponent from "../../components/sweetAlertComponent";
import "./push-notifications.css";
import { Breadcrumbs } from "../../components/partial/Breadcrumbs";
let lat, long;

class PushNotifications extends Component {
  static contextType = PHLContext;
  constructor(props) {
    super(props);
    this.state = {
      pushs: [],
      push: {},
      isLoading: false,
      totalRecords: 0,
      currentPage: 1,
      limit: 10,
      activeId: "",
      sortBy: "createdAt",
      order: "desc",
      search: "",
      newRecord: false,
      isFilterApplied: false,
      showAddForm: false,
      isEdit: false,
    };
    this.emitSearch = debounce(this.onSearch, 200);
  }
  componentDidMount = () => {
    let { socket } = this.context;
    if (socket) {
      socket.on(SocketEvents.NEW_SCAN_ADDED, (data) => {
        let newData = [...this.state.pushs];
        const alreadyExistIndex = newData.findIndex(
          (item) => item.scanId === data[0].scanId
        );
        if (alreadyExistIndex > -1) {
          newData.splice(alreadyExistIndex, 1);
          newData.unshift(...data);
        } else {
          newData.splice(-1, 1);
          newData.unshift(...data);
        }
        this.setState({ pushs: newData });
      });
    }
    this.handleQueryParams();
  };
  handleQueryParams = async () => {
    const {
      location: { search },
    } = this.props;
    const query = qs.parse(search);
    if (query && query.sort === "location") {
      const position = await new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(resolve, reject);
      });
      lat = position.coords.latitude;
      long = position.coords.longitude;
    }
    this.setState(
      {
        currentPage: query.page ? parseInt(query.page) : 1,
        limit: query.limit ? parseInt(query.limit) : 10,
        sortBy: query.sort || "createdAt",
        order: query.order
          ? query.order
          : // : query.sort === 'scan_id' || query.sort === 'created_at'
            // ? 'desc'
            "desc",
        search: query.search || "",
        isFilterApplied: query.sort || query.search ? true : false,
      },
      () => this.fetchScanRecords()
    );
  };

  openAddModal = () => {
    this.setState({
      isEdit: true,
      showAddForm: true,
    });
  };

  componentDidUpdate = ({ location: { search: prevSearch } }) => {
    const {
      location: { search },
    } = this.props;
    if (prevSearch !== search) {
      this.handleQueryParams();
    }
  };

  fetchScanRecords = async () => {
    const { currentPage, sortBy, search, limit, newRecord, order } = this.state;
    let skip = limit * (currentPage - 1);
    let data = {
      skip,
      limit,
      sortBy,
      search,
      order,
      lat,
      long,
    };
    this.setState({
      isLoading: newRecord ? false : true,
    });
    if (search && this.state.isLoading) {
      new ApiHelper().cancelRequest("cancel");
    }
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.PUSHS_LIST.service,
      ApiRoutes.PUSHS_LIST.url,
      ApiRoutes.PUSHS_LIST.method,
      ApiRoutes.PUSHS_LIST.authenticate,
      data,
      undefined
    );
    this.setState({
      isLoading: false,
    });
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      const {
        data: { pushs, totalRecords },
      } = response.data;
      this.setState({ pushs, totalRecords, newRecord: false });
    }
  };

  onLimitChange = (limit) => {
    const {
      location: { search, pathname },
    } = this.props;
    const query = qs.parse(search);
    this.props.history.push(
      [pathname, qs.stringify({ ...query, page: 1, limit })].join("?")
    );
  };
  onPageChanged = (page) => {
    const { currentPage } = this.state;
    if (page !== currentPage) {
      const {
        location: { search, pathname },
      } = this.props;
      const query = qs.parse(search);
      this.props.history.push(
        [pathname, qs.stringify({ ...query, page })].join("?")
      );
    }
  };

  setFilter = (sortBy, order) => {
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    if (sortBy) {
      params.sort = sortBy;
    }
    if (order) {
      params.order = order;
    }
    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };

  handleChange = (event) => {
    const {
      target: { name, value },
    } = event;
    this.setState({ [name]: value });
    event.persist();
    this.emitSearch();
  };

  handleAddCancel = (event) => {
    this.setState({
      push: {},
      isEdit: false,
      showAddForm: false,
    });
    if (event) event.preventDefault();
    else this.fetchScanRecords();
  };

  onSearch = () => {
    const { search } = this.state;
    const {
      props: {
        location: { search: searchParam, pathname },
      },
    } = this;
    const query = qs.parse(searchParam);
    let params = {};
    params.page = 1;
    params.search = search;
    this.props.history.push(
      [pathname, qs.stringify({ ...query, ...params })].join("?")
    );
  };

  componentWillUnmount = () => {
    this.emitSearch.cancel();
  };

  onEdit = (push) => {
    this.setState({
      isEdit: true,
      // showAddForm: true,
    });
  };
  viewUser = (push) => {
    this.setState({
      push: push,
      isEdit: false,
      showAddForm: true,
    });
  };

  onDelete = async (id) => {
    const { value } = await SweetAlertComponent({
      // title: "",
      text: `Are you sure, you want to delete?`,
    });
    if (!value) {
      return;
    }
    this.setState({
      isLoading: true,
    });
    const response = await new ApiHelper().FetchFromServer(
      ApiRoutes.DELETE_PUSHS.service,
      ApiRoutes.DELETE_PUSHS.url.replace(":id", id),
      ApiRoutes.DELETE_PUSHS.method,
      ApiRoutes.DELETE_PUSHS.authenticate,
      undefined,
      undefined
    );
    this.setState({
      id: "",
      showAddForm: false,
    });
    if (response && response.isError) {
      toast.error(response.messages[0]);
    } else {
      await this.fetchScanRecords();

      toast.success(response.messages[0]);
    }
  };

  render() {
    const {
      pushs,
      isFilterApplied,
      isLoading,
      totalRecords,
      currentPage,
      limit,
      sortBy,
      order,
      search,
    } = this.state;
    const {
      props: {
        location: { pathname },
      },
    } = this;
    const filtersOption = [
      {
        label: "Title",
        value: "title",
      },
      {
        label: "Subject",
        value: "subject",
      },
      {
        label: "Send To",
        value: "sendTo",
      },
      {
        label: "Date Scheduled",
        value: "dateScheduled",
      },
    ];

    const pagesOption = [
      {
        label: "10 Per page",
        value: 10,
      },
      {
        label: "20 Per page",
        value: 20,
      },
      {
        label: "50 Per page",
        value: 50,
      },
    ];
    return (
      <div className="container-fluid fluid-pd-2">
        <h1 className="h3-head-mob d-md-none">Push Notifications</h1>
        <Breadcrumbs pathname={pathname} />
        <div className="card card-pagination card-main">
          <div className="card-header py-7550 align-items-center justify-content-between">
            <div className="row">
              <div className="col-md-3 head-col-lg">
                <h6 className="font-book"> </h6>
              </div>
              <div className="col-md-10 mob-filter-data">
                <Dropdown className="no-arrow dp-right">
                  <Dropdown.Toggle
                    variant="secondary"
                    id="dropdown-basic"
                    className={"filter-btn-mob"}
                  >
                    <img src={pageDropdownIcon} alt="" />
                  </Dropdown.Toggle>

                  <Dropdown.Menu className="shadow dropdown-menu-right dropdown-opt-mob mob-drp">
                    {filtersOption.map(({ label, value }, index) => (
                      <Dropdown.Item
                        as="div"
                        key={index}
                        onClick={() => this.setFilter(value)}
                      >
                        {label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>

                <div className="dropdown no-arrow dp-right">
                  <button
                    type="button"
                    className="btn btn-secondary filter-btn-mob"
                    id="statusMenuLink-mob"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <img src={mobSearchIcon} alt="" />
                  </button>
                </div>
              </div>

              <div className="col-md-9 filter-col-lg">
                <div className="no-arrow dp-right dropdown">
                  <Button className="pushButtonCZ" onClick={this.openAddModal}>
                    Send New
                  </Button>
                </div>
                <FilterComponent
                  options={filtersOption}
                  selectedFilter={sortBy}
                  onFilterChange={this.setFilter}
                />
                <SearchFilter
                  placeholder={"Search by Title or Subject"}
                  search={search}
                  onChange={this.handleChange}
                />
              </div>
            </div>
          </div>
          <ListComponent
            pushs={pushs}
            isFilterApplied={isFilterApplied}
            isLoading={isLoading}
            totalRecords={totalRecords}
            limit={limit}
            currentPage={currentPage}
            onPageChanged={this.onPageChanged}
            setFilter={this.setFilter}
            order={order}
            sortBy={sortBy}
            onEdit={this.onEdit}
            onDelete={this.onDelete}
            viewUser={this.viewUser}
          />
        </div>
        <div className="footer-pg custom-align">
          {!isLoading ? (
            <div className="float-left mt-2">
              <p className="page-desc-left">
                Total: <span className="bold-black">{totalRecords}</span>
              </p>
            </div>
          ) : null}
          <div className="float-right mt-2">
            <p className="page-desc ml-2 float-right">Table View</p>

            <Dropdown className="no-arrow dp-right ml-2">
              <Dropdown.Toggle
                variant="secondary"
                id="dropdown-basic"
                className={"filter-btn"}
              >
                {" "}
                <span className="staff-value">
                  {
                    (
                      pagesOption.filter(
                        (filter) => filter.value === limit
                      )[0] || {}
                    ).label
                  }
                </span>{" "}
                <img src={filterarrowIcon} alt="" />
              </Dropdown.Toggle>
              <Dropdown.Menu className="shadow top-open dropdown-menu-right dropdown-staff">
                {pagesOption.map(({ label, value }, index) => (
                  <Dropdown.Item
                    as="div"
                    key={index}
                    onClick={() => this.onLimitChange(value)}
                  >
                    {label}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>
            {!isLoading && totalRecords > limit ? (
              <div className="float-right">
                <Pagination
                  totalRecords={totalRecords}
                  currentPage={currentPage}
                  pageLimit={limit}
                  onPageChanged={this.onPageChanged}
                />
              </div>
            ) : null}
          </div>
        </div>
        <Modal
          show={this.state.showAddForm}
          onHide={this.handleAddCancel.bind(this)}
          size="lg"
          className="proAddCZ pushNotificationModal"
          centered
        >
          <Modal.Header>
            <Modal.Title className="w-100">
              <div className="d-flex align-items-center justify-content-between">
                <span>Schedule Push Notification</span>
                {this.state.push.id && (
                  <Dropdown className="no-arrow ">
                    <Dropdown.Toggle className="pushButtonCZ">
                      Action
                    </Dropdown.Toggle>
                    <Dropdown.Menu className="shadow pushNotify dropdown-menu-right">
                      <Dropdown.Item
                        as="div"
                        disabled={
                          new Date().toISOString() >
                          this.state.push?.dateScheduled
                            ? true
                            : false
                        }
                        onClick={this.onEdit}
                      >
                        Edit
                      </Dropdown.Item>
                      <Dropdown.Item
                        as="div"
                        disabled={
                          new Date().toISOString() >
                          this.state.push?.dateScheduled
                            ? true
                            : false
                        }
                        onClick={() => this.onDelete(this.state.push.id)}
                      >
                        Delete
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                  // <Dropdown className="pushButtonCZ">Action</Dropdown>
                )}
              </div>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <AddFormComponent
              push={this.state.push}
              isEdit={this.state.isEdit}
              handleAddCancel={this.handleAddCancel}
            />
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

export default PushNotifications;
